import DefaultLayout from '##/Default';
import Dashboard from './Dashboard';

const routes = [
    {
        path: '/',
        exact: true,
        layout: DefaultLayout,
        component: Dashboard,
        auth: true,
        title: 'Dashboard'
    }
];


export default routes;
